<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">
        <!-- MIS XV ESQUasdaasdasdasdasdasdasdasddasasdadaasdagZQUIERDA -->
        <div class="mis-xv-wrapper-fixed">
          <img
            ref="coronaRef"
            src="@/assets/corona.png"
            alt="Ornamento"
            class="ornamento-img floating"
          >
          <div
            ref="misXvTopRef"
            class="mis-xv-top glowing"
          >
            MY XV
          </div>
        </div>

        <!-- Nombres sy Fesscha -->
        <div
          ref="nombreRef"
          class="centered-text"
        ><br><br><br> 
          ISABELA<br> 
            <span class="apellido">Ramirez </span>

          <br><br>
          <div
            ref="fechaRef"
            class="fecha-evento"
          >
            <span class="fecha-dia"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-mes"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-anio"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null)
    const nombreRef = ref(null)
    const fechaRef = ref(null)
    const misXvTopRef = ref(null)
    const coronaRef = ref(null)

    onMounted(() => {

      /* FONDO */
      gsap.from(fotoPortadaRef.value, {
        opacity: 0,
        y: 100,
        duration: 1.5,
        ease: 'power3.out'
      })

      const entradaPrincipal = gsap.timeline({ delay: 1 })

      entradaPrincipal.fromTo(
        coronaRef.value,
        {
          opacity: 0,
          y: -120,
          scale: 2.4,
          filter: 'blur(10px)'
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          filter: 'blur(0px)',
          duration: 1.6,
          ease: 'power4.out'
        },
        0
      )

      entradaPrincipal.from(
        misXvTopRef.value,
        {
          opacity: 0,
          y: 40,
          duration: 1.2,
          ease: 'power3.out'
        },
        0
      )

      entradaPrincipal.from(
        nombreRef.value,
        {
          opacity: 0,
          y: 40,
          duration: 1.3,
          ease: 'back.out(1.7)'
        },
        0
      )

      gsap.to(fechaRef.value.children, {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.2,
        ease: 'power3.out',
        delay: 3
      })

      gsap.to(coronaRef.value, {
        y: '-=8',
        duration: 3,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        delay: 3.6
      })
    })

    return {
      fotoPortadaRef,
      nombreRef,
      fechaRef,
      misXvTopRef,
      coronaRef
    }
  }
}
</script>

<style scoped>
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 105vh;
  overflow: hidden;
  margin-top: -60px;
  background-image: 
    linear-gradient(to bottom, rgba(255,255,255,0), rgba(0, 0, 0, 0.196)), 
    url('@/assets/Isabela-25_11zon (1).webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 1;
}

/* 🔥 SOLO AQUÍ EL CAMBIO */
.overlay {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 2;

  /* 👇 oscurece ligeramente la parte baja */
  background: linear-gradient(
    to bottom,
    rgba(0,0,0,0.05),
    rgba(0, 0, 0, 0.153)
  );
}

/* MIS XV */
.mis-xv-wrapper-fixed {
  position: absolute;
  top: -25px;
  right: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
}

.ornamento-img{
  width:40px;
  opacity:0;
  margin-top: 50px;
  filter:brightness(0) invert(1);
  margin-bottom:4px;
}

.mis-xv-top {
  font-family: 'file';
  font-size: 20px;
  letter-spacing: 1px;
  color: white;
}
.apellido{
  font-family: 'british', cursive; /* 👈 tu fuente */
  display: inline-block;
   line-height: 1.7;
}
.centered-text {
  text-align: center;
  padding-top: 240px;
  font-family: 'cursivatitulo', serif;
  font-size: 44px;
  line-height: 1;  background: white;
  -webkit-background-clip: text;
  color: transparent;
}

.fecha-evento {
  color: white;
  font-size: 18px;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.fecha-evento span {
  opacity: 0;
  transform: translateY(20px);
}
</style>
